/**
 * azure-functions/shared/compliance/formatDate.cjs
 *
 * CANONICAL COPY of `fmtDate`. `src/utils/formatting.js` re-exports it, so the
 * gate reasons evaluateControl writes read the same in the browser and on the
 * server. Kept to this one formatter: the compliance engine needs nothing else
 * from formatting.js.
 */

'use strict';

/**
 * Format a date as `04 Mar 2026`. Returns an em dash for missing/invalid input.
 * @param {string|number|Date|null|undefined} iso
 * @returns {string}
 */
const fmtDate = (iso) => {
  if (!iso) return '—';
  const d = new Date(iso);
  return isNaN(d.getTime())
    ? '—'
    : d.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
};

module.exports = { fmtDate };
